import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';

import Input from '../../../../components/Input';
import TextareaWysiwyg from '../../../../components/TextareaWysiwyg';
import Toggle from '../../../../components/Toggle';

export default function Form() {
  return (
    <SpaceBetween size="m">
      <Input name="title" label="Titel" stretch />
      <TextareaWysiwyg name="text" label="Text" stretch />
      <Box>
        <SpaceBetween size="s">
          <Toggle
            defaultValue={true}
            label="Aktive"
            description="Soll dieser Eintrag auf der Webseite sichtbar sein."
            name="is_active"
          />
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  );
}
